import { Checkbox } from '@mantine/core'
import { memo } from 'react'

import { type FilterOption } from '../multi-select/filterTypeConfig'
import { CheckboxBadgeOption } from './badgeOption/CheckboxBadgeOption'
import styles from './styles.module.css'

export const CheckboxGroup = memo(
  ({
    options,
    value,
    onChange,
    ...props
  }: Readonly<{
    options: FilterOption[]
    value: string[]
    onChange: (value: string | string[]) => void
  }>) => {
    return (
      <Checkbox.Group
        classNames={{ root: styles.checkBoxGroup }}
        value={value}
        onChange={onChange}
        {...props}
      >
        {Boolean(options?.length) &&
          options.map((option: FilterOption) => (
            <Checkbox
              key={option.value}
              value={option.value}
              classNames={{ body: styles.checkBoxBody }}
              label={
                option.badgeColor ? (
                  <CheckboxBadgeOption option={option} />
                ) : (
                  option.label
                )
              }
            />
          ))}
      </Checkbox.Group>
    )
  }
)

CheckboxGroup.displayName = 'CheckboxGroup'
